import { useState } from 'react';

const useUploadUIState = () => {
  // UI state
  const [isLoading, setIsLoading] = useState(false);
  const [isFirstSectionComplete, setIsFirstSectionComplete] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [isResetConfirmed, setIsResetConfirmed] = useState(false);
  const [error, setError] = useState({ show: false, message: '' });
  
  return {
    isLoading,
    setIsLoading,
    isFirstSectionComplete,
    setIsFirstSectionComplete,
    showDialog,
    setShowDialog,
    isResetConfirmed,
    setIsResetConfirmed,
    error,
    setError,
  };
};

export default useUploadUIState;
